import VueMeta from 'vue-meta';
import Vue from 'vue';

Vue.use(VueMeta, {
    
  
});
